<template>
    <q-dialog 
        :model-value="modelValue"
        @update:model-value="$emit('update:modelValue', $event)"
        @before-show="fetchAssignedWorkers()"
    >
        <q-card flat square bordered style="width: 875px;max-width: 90vw;">
            <q-toolbar>
                <q-icon size="sm" name="mdi-percent" />

                <q-toolbar-title>
                    <slot name="title">Worker Split</slot>
                </q-toolbar-title>
                
                <q-btn
                    dense
                    flat
                    icon="mdi-close"
                    @click="cancel"
                />
            </q-toolbar>

            <q-separator />

            <q-card-section class="q-pa-none">
                <q-tab-panels animated v-model="tab">
                    <q-tab-panel class="q-pa-none" name="split">
                        <!-- <LumperSplitModel 
                            dense
                            v-model:pay="workerSplitCache"
                        /> -->
                        <WorkerSplitModel 
                            dense
                            v-model:worker-splits="workerSplitCache"
                            :work-start-at="workStartAt"
                        />

                        <q-item class="q-my-lg" v-if="!workerSplitCache.length">
                            <q-item-section class="text-center text-grey-7">
                                <q-item-label class="text-subtitle1">
                                    <q-icon class="q-mr-xs" name="mdi-alert-circle-outline" />
                                    *No Workers Found*
                                </q-item-label>
                            </q-item-section>
                        </q-item>

                        <q-item class="text-center" dense>
                            <q-item-section>
                                <q-btn
                                    size="sm"
                                    icon="mdi-account-plus-outline"
                                    :color="$q.dark.isActive ? 'green-13' : 'green'"
                                    :outline="$q.dark.isActive"
                                    label="Add Worker"
                                    @click="tab = 'assign'"
                                ></q-btn>
                            </q-item-section>
                        </q-item>
                    </q-tab-panel>
                    <q-tab-panel class="q-pa-none" name="assign">
                        <div class="text-subtitle1 q-pa-sm q-px-md">
                            <!-- <q-icon class="q-mr-xs" name="mdi-account-multiple-outline" /> -->
                            Assign workers that are getting paid from this work item.
                        </div>

                        <q-separator />

                        <q-item class="q-pa-sm">
                            <q-item-section>
                                <q-input
                                    filled
                                    square
                                    dense
                                    v-model="workers.search"
                                    :label="`Search assigned workers...`"
                                    :clearable="!loading"
                                    debounce="250"
                                    @update:model-value="v => fetchAssignedWorkers()"
                                >
                                    <template v-slot:append>
                                        <q-btn
                                            flat
                                            dense
                                            round
                                            icon="mdi-magnify"
                                            :disable="loading"
                                            @click="fetchAssignedWorkers"
                                        />
                                    </template>
                                </q-input>
                            </q-item-section>
                        </q-item>
                        

                        <q-separator />

                        <q-item class="q-pa-none">
                            <q-item-section class="q-pa-sm">
                                <q-select
                                    filled
                                    square
                                    dense
                                    v-model="workers.rows"
                                    label="Rows per page"
                                    :options="[5, 10, 15, 20]"
                                    @update:model-value="fetchAssignedWorkers"
                                />
                            </q-item-section>

                            <q-separator vertical />

                            <q-item-section class="q-pa-sm">
                                <q-select
                                    filled
                                    square
                                    dense
                                    v-model="workers.role"
                                    label="Role"
                                    emit-value
                                    map-options
                                    :options="[
                                        { label: 'All', value: null },
                                        { label: 'Administrator', value: 1 },
                                        { label: 'Manager', value: 2 },
                                        { label: 'Lead', value: 3 },
                                        { label: 'Lumper', value: 4 },
                                    ]"
                                    @update:model-value="fetchAssignedWorkers"
                                />
                            </q-item-section>
                        </q-item>

                        <q-separator />

                        <q-item class="q-my-lg" style="opacity: 0.75;" v-if="!workers.data.length">
                            <q-item-section class="text-center text-grey-7">
                                <q-item-label class="text-subtitle1">
                                    <q-icon class="q-mr-xs" size="sm" name="mdi-alert-circle-outline" />
                                    No Workers Found
                                </q-item-label>

                                <q-item-label class="text-secondary" v-if="workers.search?.length??false" caption>
                                    <q-icon class="q-mr-xs" size="xs" name="mdi-lightbulb-on-outline" />
                                    Try searching for a different worker.
                                </q-item-label>

                                <q-item-label class="text-negative" v-else-if="!workers.total" caption>
                                    <q-icon class="q-mr-xs" size="xs" name="mdi-alert-outline" />
                                    No workers are assigned!
                                </q-item-label>
                            </q-item-section>
                        </q-item>

                        <q-list separator>
                            <q-item v-for="worker in workers.data" tag="label" v-ripple>
                                <q-item-section avatar>
                                    <q-checkbox 
                                        color="primary" 
                                        @update:model-value="(val) => handleLumperCheckbox(val, worker)"
                                        :model-value="workerSplitCache.findIndex(v => v.labor_id == worker.id) > -1"
                                    />
                                </q-item-section>
                                <q-item-section side>
                                    <Avatar
                                        size="md"
                                        :user="worker"
                                    />
                                </q-item-section>
                                <q-item-section>
                                    <q-item-label>{{ worker.name }}</q-item-label>
                                    <q-item-label caption>ID: {{ worker.id }}</q-item-label>
                                </q-item-section>
                                <q-item-section side>
                                    <q-item-label>
                                        <q-badge
                                            :color="roleColor(worker.role.name)"
                                            :label="worker.role.name"
                                        />
                                    </q-item-label>
                                </q-item-section>
                            </q-item>

                            <!-- Add pagination -->
                            <q-item v-if="workers.total > workers.rows">
                                <q-item-section class="text-center">
                                    <q-btn
                                        flat
                                        dense
                                        :disable="workers.page == 1"
                                        icon="mdi-chevron-left"
                                        @click="workers.page--"
                                    />
                                </q-item-section>
                                <q-item-section class="text-center">
                                    <q-item-label>{{ workers.page }} / {{ Math.ceil(workers.total / workers.rows) }}</q-item-label>
                                </q-item-section>
                                <q-item-section class="text-center">
                                    <q-btn
                                        flat
                                        dense
                                        :disable="workers.page == Math.ceil(workers.total / workers.rows)"
                                        icon="mdi-chevron-right"
                                        @click="workers.page++"
                                    />
                                </q-item-section>
                            </q-item>
                        </q-list>
                    </q-tab-panel>
                </q-tab-panels>

                <q-inner-loading :showing="loading">
                    <q-spinner size="1.5rem" />
                </q-inner-loading>
            </q-card-section>

            <q-card-actions>
                <q-btn
                    no-caps
                    label="Submit"
                    color="positive"
                    @click="save()"
                    :disable="loading"
                    v-if="tab == 'split'"
                />
                <q-btn
                    v-else
                    no-caps
                    label="Split Workers"
                    icon="mdi-percent"
                    color="primary"
                    @click="tab = 'split'"
                />
                <q-btn
                    flat
                    label="Reset"
                    color="primary"
                    @click="reset"
                    :disable="loading || !isModified"
                />
                <q-btn
                    flat
                    label="Cancel"
                    color="negative"
                    @click="cancel"
                />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>

<script>
import Avatar from '@/Components/Avatar.vue';

import WorkerSplitModel from '@/Components/Models/WorkerSplitModel/WorkerSplitModel.vue';

export default {
    name: 'WorkerSplitDialog',
    emits: [
        'update:modelValue',
        'update:pay',
        'cancel',
        'save',
    ],
    components: {
        Avatar,
        WorkerSplitModel,
    },
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        customerId: {
            type: Number,
            required: true,
        },
        workItemId: {
            type: Number,
            required: true,
        },
        pay: {
            type: Array,
            default: () => [],
        },
        workStartAt: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            loading: false,
            workerSplitCache: [],
            tab: 'split',
            workers: {
                data: [],
                total: 0,
                rows: 5,
                page: 1,
                descending: true,
                role: null,
                sort: 'created_at',
                search: '',
            }
        };
    },
    methods: {
        async fetchAssignedWorkers() {
            if (!this.customerId || this.loading) return;
            this.loading = true;
            try {
                const result = await this.workOrderDialogStore.fetchAssignedWorkers(this.customerId, {
                    page: this.workers.page,
                    rows: this.workers.rows,
                    role: this.workers.role,
                    search: this.workers.search,
                });
                this.workers.data = result?.rows ?? [];
                this.workers.total = result?.meta?.total ?? result?.total ?? 0;
            } catch (error) {
                this.$q.notify({ color: 'negative', message: 'Failed to fetch assigned workers.' });
            } finally {
                this.loading = false;
            }
        },
        handleLumperCheckbox(val, worker) {
            const index = this.workerSplitCache.findIndex(v => v.labor_id === worker.id);

            if (index > -1) {
                this.workerSplitCache.splice(index, 1);
                return;
            }

            this.workerSplitCache.push({
                worker,
                pay: 0.00,
                split: 0.00,
                labor_id: worker.id,
                work_item_id: this.workItemId,
                hours: 0,
                time_start: this.formatTo('yyyy-MM-dd HH:mm:00', this.workStartAt),
                time_end: this.formatTo('yyyy-MM-dd HH:mm:00', this.workStartAt),
            });
        },
        cancel() {
            if (this.isModified) { 
                if (!window.confirm('Are you sure you want to cancel?')) return;
            }

            this.$emit('update:modelValue', false);
        },
        save(override = false) {
            const totalSplit = this.workerSplitCache.map(v => v.split).reduce((a, b) => a + b, 0);

            if (totalSplit < 100 && !override) {
                this.$q.notify({
                    color: 'deep-orange',
                    icon: 'mdi-alert-circle-outline',
                    message: 'Workers total split percentage is less than 100%',
                    actions: [
                        { label: 'Override', color: 'white', handler: () => this.save(true) },
                    ]
                });
                return;
            }
            
            if (totalSplit !== 100 && !override) {
                this.$q.notify({
                    color: 'deep-orange',
                    icon: 'mdi-alert-circle-outline',
                    message: 'Worker split percentage must be equal to 100%' + totalSplit,
                    actions: [
                        { label: 'Override', color: 'white', handler: () => this.save(true) },
                    ]
                });
                return;
            }

            this.$emit('update:pay', this.workerSplitCache);
            this.$emit('update:modelValue', false);
        },
        reset() {
            this.workerSplitCache = [...this.pay];
        },
    },
    computed: {
        isModified() {
            return JSON.stringify(this.workerSplitCache) !== JSON.stringify(this.pay);
        }
    },
    mounted() {
        this.workerSplitCache = [...this.pay];
    },
    watch: {
        modelValue(to) {
            if (to) {
                this.workerSplitCache = [...this.pay];

                this.tab = 
                    !this.workerSplitCache.length ? 
                        'assign' : 
                        'split';
                return;
            }

            this.workers = {
                data: [],
                total: 0,
                rows: 5,
                page: 1,
                descending: true,
                sort: 'created_at'
            };

            this.workerSplitCache = [];
        },
        'workers.page'(to) {
            this.fetchAssignedWorkers();
        },
    },
}
</script>